import "@fontsource/nunito";

export const onRouteUpdate = () => {
  document.querySelector("#page-loader").style["display"] = "none";
};
